import { Chip, Grid, Paper, Typography } from '@mui/material';
import { FormSectionTitle } from '../../../../../components/form-page-parts';
import { IAmendmentResponse } from '../../../../../model/sge/amendment/response/amendment-response';
import { getAmendmentStatus, getAmendmentTypeLabel } from '../../../../../model/sge/amendment/amendment-enums';
import { IParlamentarianPagedResponse } from '../../../../../model/sge/parlamentarian/response/parlamentarian-paged-response';
import { IPoliticalPartyPagedResponse } from '../../../../../model/sge/political-party/response/political-party-paged-response';
import { formatCurrency } from '../../../../../utils/format';
import { formatCodeName } from '../../../components/code-name-label';
import { InfoField } from './detail-parts';

interface AmendmentSummaryProps {
    amendment?: IAmendmentResponse;
    parlamentarian?: IParlamentarianPagedResponse;
    politicalParty?: IPoliticalPartyPagedResponse;
}

export function AmendmentSummary({ amendment, parlamentarian, politicalParty }: AmendmentSummaryProps) {
    const status = getAmendmentStatus(amendment?.status);
    return (
        <Paper sx={{ p: 3 }} elevation={3}>
            <FormSectionTitle title="Informações Gerais" first />
            <Grid container spacing={3}>
                <Grid item xs={6} md={3}>
                    <InfoField label="Status" value={<Chip label={status?.label || '-'} color={status?.color || 'default'} size="small" />} />
                </Grid>
                <Grid item xs={6} md={3}>
                    <InfoField label="Valor Total" value={<Typography variant="body1" sx={{ fontWeight: 600 }}>{formatCurrency(amendment?.totalAmount)}</Typography>} />
                </Grid>
                <Grid item xs={6} md={3}>
                    <InfoField label="Exercício" value={amendment?.year} />
                </Grid>
                <Grid item xs={6} md={3}>
                    <InfoField label="Tipo" value={getAmendmentTypeLabel(amendment?.type)} />
                </Grid>
            </Grid>

            <FormSectionTitle title="Vinculação" />
            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <InfoField label="Parlamentar" value={parlamentarian?.personName} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <InfoField label="Partido Político" value={politicalParty ? `${politicalParty.abbreviation} - ${politicalParty.name}` : undefined} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <InfoField label="Unidade Orçamentária" value={formatCodeName({ code: amendment?.budgetUnitCode, name: amendment?.budgetUnitName })} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <InfoField label="Programa Orçamentário" value={formatCodeName({ code: amendment?.budgetProgramCode, name: amendment?.budgetProgramName })} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <InfoField label="Ação Orçamentária" value={formatCodeName({ code: amendment?.budgetActionCode, name: amendment?.budgetActionName })} />
                </Grid>
            </Grid>

            <FormSectionTitle title="Detalhes" />
            <Grid container spacing={3}>
                <Grid item xs={12}><InfoField label="Descrição do Objeto" value={amendment?.objectDescription} /></Grid>
                <Grid item xs={12}><InfoField label="Base Legal" value={amendment?.legalBasis} /></Grid>
                <Grid item xs={12}><InfoField label="Finalidade Pública" value={amendment?.publicPurpose} /></Grid>
                <Grid item xs={12}><InfoField label="Justificativa Institucional" value={amendment?.institutionalJustification} /></Grid>
                <Grid item xs={12} md={6}><InfoField label="Público-Alvo" value={amendment?.targetAudience} /></Grid>
                <Grid item xs={12} md={6}><InfoField label="Local de Execução" value={amendment?.executionLocation} /></Grid>
            </Grid>
        </Paper>
    );
}
